import { MaterialTree } from '../models/material-tree';
import { TreeUtils } from './tree-utils';

export class TreeCommandsHandler {

    constructor(private materialTree: MaterialTree, private treeUtils: TreeUtils) {
    }

    checkAll() {
        this.treeUtils.checkAll();
    }

    unCheckAll() {
        this.treeUtils.unCheckAll();
    }

    toggleGroup(node) {
        this.treeUtils.toggleGroup(node);
    }

    expandAll() {
        this.treeUtils.expandAll();
    }

    collapseAll() {
        this.treeUtils.collapseAll();
    }

    expandGroup(node) {
        this.treeUtils.expandNode(node);
    }

    collapseGroup(node) {
        this.treeUtils.collapseNode(node);
    }

    checkGroup(node) {
        this.treeUtils.checkGroup(node);
        this.treeUtils.expandNode(node);
    }

    unCheckGroup(node) {
        this.treeUtils.unCheckGroup(node);
    }

}
